export const defaultPrompts = {
  none: '',
}
